/* DiFluid OS chrome.
   Loaded with defer from snippets/os-head.liquid, after os-content.js,
   so the document is parsed and the copy deck is present by the time
   any of this runs. */

/* The visitor's language root ("/", "/de/", "/de-at/"). Cart requests go
   through it so the cart and checkout open in the visitor's language. */
function osRoot() {
  var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  return r.charAt(r.length - 1) === "/" ? r : r + "/";
}

/* Fixed words on screen, in the visitor's language when the theme's
   language files carry them, the English otherwise. Display only:
   nothing tracked or stored goes through this. */
function T(k, en) { var t = window.OS_T; return (t && typeof t[k] === "string" && t[k]) || en; }

(function () {
  "use strict";

  var D = document;
  var REDUCED_MOTION = window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var C = window.OS_CONTENT || { HOME: { head: {} }, STAGES: {}, pick: function () { return ""; } };
  var OS_SELECTOR =
    ".os-header, .os-sidebar, .os-tabs, .os-more, .os-region, .os-home, .os-room, .os-shell, .os-who";


  /* ───────────────────────────────────────────
     0. Copy written in Shopify wins
     Each section can print a block of overrides. Anything set in the
     theme editor replaces the default in os-content.js; anything left
     blank keeps the default, so a half-filled section still reads
     properly. Nothing here needs a code change to edit a line.
     ─────────────────────────────────────────── */
  function deepFill(target, src) {
    if (!src || typeof src !== "object") return;
    for (var k in src) {
      if (!Object.prototype.hasOwnProperty.call(src, k)) continue;
      var v = src[k];
      if (v === null || v === undefined) continue;
      if (typeof v === "string") {
        if (v.length) target[k] = v;           /* blank = keep default */
      } else if (typeof v === "object" && !(v instanceof Array)) {
        if (!target[k] || typeof target[k] !== "object") target[k] = {};
        deepFill(target[k], v);
      } else {
        target[k] = v;
      }
    }
  }

  /* A number never wraps away from its unit. "from 5 g" broke as
     "from 5" / "g". Every string in the copy deck, and every text node
     the sections print, gets a no-break space between a number and the
     unit after it. Runs after the theme editor's copy is merged in. */
  var UNIT_RE = /(\d)[ ](g\/L|g\b|kg\b|mg\b|ml\b|mL\b|L\b|°C|°F|%|aw\b|µm|mm\b|cm\b|s\b|min\b|h\b|V\b|W\b|Agtron\b|ppm\b)/g;
  var NBSP = String.fromCharCode(160);
  function keepUnits(str) { return str.replace(UNIT_RE, "$1" + NBSP + "$2"); }
  function keepUnitsDeep(o, seen) {
    if (!o || typeof o !== "object") return;
    seen = seen || [];
    if (seen.indexOf(o) >= 0) return;
    seen.push(o);
    for (var k in o) {
      if (!Object.prototype.hasOwnProperty.call(o, k)) continue;
      var v = o[k];
      if (typeof v === "string") { if (UNIT_RE.test(v)) { UNIT_RE.lastIndex = 0; o[k] = keepUnits(v); } UNIT_RE.lastIndex = 0; }
      else if (v && typeof v === "object") keepUnitsDeep(v, seen);
    }
  }
  function keepUnitsInPage(root) {
    if (!root || !D.createTreeWalker) return;
    var w = D.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var n;
    while ((n = w.nextNode())) {
      var p = n.parentNode && n.parentNode.nodeName;
      if (p === "SCRIPT" || p === "STYLE" || p === "TEXTAREA") continue;
      var t = n.nodeValue;
      if (t && /\d /.test(t)) {
        var u = keepUnits(t);
        if (u !== t) n.nodeValue = u;
      }
    }
  }

  function applyCopy() {
    var nodes = D.querySelectorAll("[data-os-copy]");
    for (var i = 0; i < nodes.length; i++) {
      var data;
      try { data = JSON.parse(nodes[i].textContent); } catch (e) { continue; }
      if (!data || !data.scope) continue;
      var scope = String(data.scope);
      delete data.scope;

      /* Every OS section's text fields were filled from its preset
         when the section was added, and an editor field always beats
         the deck. A field that still holds the line it shipped with
         word for word was never edited, so it is dropped and the
         deck's current line shows. Edited fields still win. The list
         lives in os-content.js (RETIRED). */
      if (C.unretire) C.unretire(data);

      if (scope === "home") deepFill(C.HOME, data);
      else if (scope === "coffeeos") deepFill(C.COFFEEOS, data);
      else if (scope === "learn") {
        if (data.head) {
          window.OS_LEARN_HEAD = window.OS_LEARN_HEAD || {};
          deepFill(window.OS_LEARN_HEAD, data.head);
        }
      } else if (scope.indexOf("stage:") === 0) {
        var room = scope.slice(6);
        if (C.STAGES[room]) {
          /* Tools arrive keyed by slug; the deck holds them as a list. */
          var toolCopy = data.tools;
          delete data.tools;
          deepFill(C.STAGES[room], data);
          if (toolCopy) {
            var list = C.STAGES[room].tools || [];
            for (var t = 0; t < list.length; t++) {
              if (toolCopy[list[t].slug]) deepFill(list[t], toolCopy[list[t].slug]);
            }
          }
        }
      }
    }
  }

  /* ───────────────────────────────────────────
     1. Assemble the shell
     ─────────────────────────────────────────── */
  /* The rail takes the sidebar. The store's own wrapper stays exactly
     where the theme put it.

     It used to be moved in here as well, which made for tidier markup
     and quietly broke the Shop page. Moving a subtree disconnects and
     reconnects every custom element inside it, and the app blocks in
     there — the collection filter among them — bind their handlers on
     their first connect. Our move happened after that and threw the
     bindings away, so the category accordions did nothing: the click
     reached the right element and nothing was listening. Re-inserting
     the app's own element by hand brought them back, which is what
     identified it.

     Moving the wrapper earlier is not a fix — an app block can
     initialize at any point — so the rail is placed beside the
     content in CSS instead, and no third-party markup is touched. */
  function buildShell() {
    var side = D.querySelector(".os-sidebar");
    var header = D.querySelector(".os-header");
    if (!side || !header || D.querySelector(".os-shell")) return;
    var shell = D.createElement("div");
    shell.className = "os-shell";
    header.after(shell);
    shell.appendChild(side);
  }

  /* ───────────────────────────────────────────
     App pages
     /apps/17TRACK is the app's own React page: no section can be
     added to it, so the one line under its heading comes from the
     copy deck (OS_CONTENT.APPS) and is put in here. The app may
     re-render its tree after load and drop the line, so the top of
     the page is watched for a few seconds and it goes back in.
     ─────────────────────────────────────────── */
  function paintApps() {
    if (!/^\/apps\/17track/i.test(location.pathname)) return;
    var A = (window.OS_CONTENT && window.OS_CONTENT.APPS) || {};
    if (!A.track) return;
    function put() {
      var h = D.querySelector('[class*="SlotLayout_layout_customer"] #Heading');
      if (!h || (h.nextElementSibling && h.nextElementSibling.classList.contains("os-track__note"))) return;
      var p = D.createElement("p");
      p.className = "os-track__note";
      p.textContent = A.track;
      h.after(p);
    }
    put();
    if (window.MutationObserver) {
      var mo = new MutationObserver(put);
      mo.observe(D.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 10000);
    }
  }

  /* ───────────────────────────────────────────
     2. Hide the theme's leftover floating widgets
     Body-level nodes only. The previous build walked every node in
     the document and called getComputedStyle on each.
     ─────────────────────────────────────────── */
  var JUNK = { USD: 1, English: 1, CoffeeOS: 1 };

  function hideFloaters() {
    var nodes = D.querySelectorAll("body > *, body > * > *");
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest(OS_SELECTOR)) continue;
      var t = (el.textContent || "").replace(/\s+/g, " ").trim();
      if (JUNK[t] !== 1) continue;
      if (window.getComputedStyle(el).position !== "fixed") continue;
      el.style.setProperty("display", "none", "important");
    }
  }

  /* ───────────────────────────────────────────
     3. Roles
     ─────────────────────────────────────────── */
  /* The order of the "I am a" menu, and of the reel behind the chip.
     Anything not in here is unreachable: the menu is built from this
     list, not from LABELS, so a role with copy but no entry here can
     be stored but never chosen. */
  var ORDER = [
    "producer", "exporter", "importer", "q", "roaster",
    "cafe", "hobby", "home", "educator", "competitor"
  ];

  var LABELS = {
    producer: "Producer / mill",
    exporter: "Exporter",
    importer: "Importer / green buyer",
    q: "Q grader / analyst",
    roaster: "Roaster",
    cafe: "Café / barista",
    hobby: "Hobby brewer",
    home: "Home roaster",
    educator: "Educator",
    competitor: "Brewing competitor"
  };

  /* Shown in the chip below 900px, so a phone-width chip cannot
     outgrow the header row. The menu always uses the full label. */
  var SHORT = {
    producer: "Producer",
    exporter: "Exporter",
    importer: "Importer",
    q: "Q grader",
    roaster: "Roaster",
    cafe: "Café",
    hobby: "Hobby brewer",
    home: "Home roaster",
    educator: "Educator",
    competitor: "Competitor"
  };

  /* LABELS stays English: it is what goes to the cart, Klaviyo, Meta,
     GA4 and localStorage (savePersona). SHORT is only ever shown, but
     stays English too as the fallback. What the visitor reads comes
     through these two. */
  function labelOf(id) { return LABELS[id] ? T("main.persona." + id, LABELS[id]) : ""; }
  function shortOf(id) {
    return SHORT[id] ? T("main.persona_short." + id, SHORT[id]) : labelOf(id);
  }

  var FEATURED = {
    roaster: [["omniflux", "New", true], ["omni", null, false], ["omix-plus", null, false]],
    cafe: [["brew-control-ti", "Lead", true], ["sensory-bcs", null, false], ["r2-extract", null, false]],
    producer: [["omix-plus", null, true], ["coffmeter-m1", null, false], ["coffmeter-w1", null, false]],
    exporter: [["omix-plus", null, true], ["roast-validation-ultimate", null, false], ["r2-extract", null, false]],
    importer: [["omix-plus", null, true], ["roast-validation-ultimate", null, false], ["coffmeter-m1", null, false]],
    q: [["omix-plus", null, true], ["moment", null, false], ["sensory-bcs", null, false]],
    hobby: [["brew-control-ti", "Lead", true], ["sensory-bcs", null, false], ["omni", null, false]],
    home: [["omni", null, true], ["coffmeter-a1", null, false], ["brew-control-ti", "Lead", false]],
    educator: [["omni", null, true], ["sensory-bcs", null, false], ["brew-control-ti", "Lead", false]],
    /* Brewing and roasting both, so the pair that covers them leads
       and the tasting instrument sits beside it. */
    competitor: [["omni", null, true], ["moment", null, false], ["r2-extract", null, false]]
  };

  var SYSTEMS = {
    roaster: ["brew-control-ti", "omni", "omix-plus", "omniflux"],
    cafe: ["brew-control-ti", "sensory-bcs", "r2-extract", "microbalance-ti"],
    producer: ["omix-plus", "coffmeter-m1", "coffmeter-w1"],
    exporter: ["omix-plus", "roast-validation-ultimate", "r2-extract"],
    importer: ["omix-plus", "roast-validation-ultimate", "coffmeter-m1"],
    /* A Q grader's day ends in a cupping, so Moment and the system
       built around it lead here rather than a second color meter. */
    q: ["sensory-bcs", "moment", "omix-plus", "omni"],
    hobby: ["brew-control-ti", "sensory-bcs", "omni", "r2-extract"],
    home: ["omni", "coffmeter-a1", "brew-control-ti"],
    educator: ["omni", "sensory-bcs", "brew-control-ti", "omix-plus"],
    competitor: ["moment", "r2-extract", "omni", "omix-plus"]
  };

  function readStored() {
    try { return JSON.parse(localStorage.getItem("difluid_persona") || "null"); }
    catch (e) { return null; }
  }

  function currentId() {
    var s = readStored();
    return (s && LABELS[s.id] && s.id) || "roaster";
  }

  /* Whether this reader has ever chosen. currentId falls back to
     roaster so every page has something to render, which means the
     chip looks answered before anyone has answered it. This is the
     only thing that can tell the two apart, and it is what the cue
     on the chip is driven by. */
  function hasPicked() {
    var s = readStored();
    return !!(s && LABELS[s.id]);
  }

  function savePersona(id) {
    var name = LABELS[id] || LABELS.roaster;
    try {
      localStorage.setItem(
        "difluid_persona",
        JSON.stringify({ id: id, label: name, t: Date.now() })
      );
    } catch (e) {}

    fetch(osRoot() + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { persona: id, "I am a": name } })
    }).catch(function () {});

    if (window.osTrack) window.osTrack("persona_selected", { persona: id, persona_label: name });
    if (window.osPersonaSync) window.osPersonaSync(true);
  }

  /* ───────────────────────────────────────────
     4. The reel
     Every label is built once and left in the DOM. Changing role
     swaps two classes, which the browser can interpolate. Rewriting
     textContent gives it nothing to move between.
     ─────────────────────────────────────────── */
  function buildReel(box) {
    var reel = box.querySelector("[data-os-reel]");
    if (!reel || reel.childElementCount) return;
    for (var i = 0; i < ORDER.length; i++) {
      var id = ORDER[i];
      var b = D.createElement("b");
      b.className = "os-reel__item";
      b.setAttribute("data-reel-role", id);

      var long = D.createElement("span");
      long.className = "os-reel__long";
      long.textContent = labelOf(id);

      var short = D.createElement("span");
      short.className = "os-reel__short";
      short.textContent = shortOf(id);

      b.appendChild(long);
      b.appendChild(short);
      reel.appendChild(b);
    }

    /* Reel items are absolutely positioned, so the reel itself has no
       width of its own and clips the longer labels. One hidden copy of
       the widest label at each breakpoint gives it a width — and keeps
       that width fixed, so the chip does not jump about as the role
       changes. The widest is found in the visitor's language; on a tie
       the English choice (importer, home) stands. */
    var wideLong = "importer", wideShort = "home";
    for (var w = 0; w < ORDER.length; w++) {
      if (labelOf(ORDER[w]).length > labelOf(wideLong).length) wideLong = ORDER[w];
      if (shortOf(ORDER[w]).length > shortOf(wideShort).length) wideShort = ORDER[w];
    }
    var sizer = D.createElement("span");
    sizer.className = "os-reel__size";
    sizer.setAttribute("aria-hidden", "true");
    sizer.innerHTML =
      '<span class="os-reel__long">' + esc(labelOf(wideLong)) + "</span>" +
      '<span class="os-reel__short">' + esc(shortOf(wideShort)) + "</span>";
    reel.appendChild(sizer);
  }

  function setReel(box, id) {
    var reel = box.querySelector("[data-os-reel]");
    if (!reel) return;
    var items = reel.querySelectorAll(".os-reel__item");
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      if (el.getAttribute("data-reel-role") === id) {
        el.classList.remove("was-on");
        el.classList.add("is-on");
      } else if (el.classList.contains("is-on")) {
        el.classList.remove("is-on");
        el.classList.add("was-on");
      } else {
        el.classList.remove("was-on");
      }
    }
    var btn = box.querySelector("[data-os-who-btn]");
    if (btn) btn.setAttribute("aria-label", T("main.i_am_a", "I am a {label}").replace("{label}", function () { return labelOf(id); }));
    /* Nothing is marked selected until a role has actually been
       chosen. The chip shows roaster before that because a page has
       to render as something, but lighting roaster in the list would
       tell a first-time reader they had already answered. */
    var picked = hasPicked();
    var opts = box.querySelectorAll("[data-role]");
    for (var j = 0; j < opts.length; j++) {
      opts[j].setAttribute(
        "aria-selected",
        picked && opts[j].getAttribute("data-role") === id ? "true" : "false"
      );
    }
  }

  /* A short ring pulse on the chip itself, so the control that was
     just used confirms it did something even if the reader's eye is
     already somewhere else on the page. */
  function pulseChips() {
    var btns = D.querySelectorAll(".os-who__btn");
    for (var i = 0; i < btns.length; i++) {
      (function (b) {
        b.classList.remove("is-pulse");
        void b.offsetWidth;
        b.classList.add("is-pulse");
        setTimeout(function () { b.classList.remove("is-pulse"); }, 950);
      })(btns[i]);
    }
  }

  /* How long the chip keeps moving before it settles. It runs while
     the reader is still on the page and has not answered, but a
     control that never stops moving in a sticky header is noise by
     the second screenful. After this it drops to the ring, the dot
     and the colored label, which stay until they choose.

     The animation itself waits 800ms for the page to finish
     arriving, and each pair of beats takes 3.6 seconds, so this is
     about seven pairs. */
  var CUE_MS = 26000;
  var cueTimer = null;

  /* Stop the motion, keep the ring. Called when the timer runs out
     and when the menu is opened, because once it has been opened the
     cue has done its job whether or not a role was chosen. */
  function settleCue() {
    if (cueTimer) { clearTimeout(cueTimer); cueTimer = null; }
    var btns = D.querySelectorAll(".os-who__btn.is-cue");
    for (var i = 0; i < btns.length; i++) btns[i].classList.remove("is-cue");
  }

  /* Both off. Only a real choice gets here. */
  function clearCue() {
    settleCue();
    var btns = D.querySelectorAll(".os-who__btn.is-ask");
    for (var i = 0; i < btns.length; i++) btns[i].classList.remove("is-ask");
  }

  function bindWho(box) {
    var btn = box.querySelector("[data-os-who-btn]");
    var panel = box.querySelector("[data-os-menu]");
    var list = box.querySelector("[data-os-roles]");
    if (!btn || !panel || !list) return;

    buildReel(box);

    /* The line above the roles is outside the listbox, so it needs an
       id to be tied back to it. Built here rather than written into
       the snippet so a second chip on the page cannot repeat the id. */
    var head = box.querySelector("[data-os-who-head]");
    if (head && !head.id) {
      head.id = "os-who-head-" + (D.querySelectorAll("[data-os-who-head]").length);
      list.setAttribute("aria-describedby", head.id);
    }

    if (!list.childElementCount) {
      for (var i = 0; i < ORDER.length; i++) {
        var b = D.createElement("button");
        b.type = "button";
        b.setAttribute("role", "option");
        b.setAttribute("data-role", ORDER[i]);
        b.textContent = labelOf(ORDER[i]);
        list.appendChild(b);
      }
    }

    setReel(box, currentId());

    /* Nobody has answered yet, so the chip says so. is-ask is the
       ring and is-cue is the movement; the two are separate because
       they stop at different moments. */
    if (!hasPicked()) {
      btn.classList.add("is-ask", "is-cue");
      if (!cueTimer) cueTimer = setTimeout(settleCue, CUE_MS);
    }

    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      var opening = panel.hidden;
      panel.hidden = !opening;
      btn.setAttribute("aria-expanded", opening ? "true" : "false");
      if (opening) settleCue();
    });

    list.addEventListener("click", function (e) {
      var b = e.target.closest("[data-role]");
      if (!b) return;
      var id = b.getAttribute("data-role");
      /* Picking the role already showing is a no-op only if it was
         actually picked. Before that the chip is showing a fallback,
         and choosing it is an answer like any other. */
      if (id === currentId() && hasPicked()) {
        panel.hidden = true;
        btn.setAttribute("aria-expanded", "false");
        return;
      }
      var same = id === currentId();
      savePersona(id);
      clearCue();
      var boxes = D.querySelectorAll(".os-who");
      for (var i = 0; i < boxes.length; i++) setReel(boxes[i], id);
      panel.hidden = true;
      btn.setAttribute("aria-expanded", "false");
      pulseChips();
      if (!same) changeRole(id);
    });

    D.addEventListener("click", function (e) {
      if (box.contains(e.target)) return;
      panel.hidden = true;
      btn.setAttribute("aria-expanded", "false");
    });

    D.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      panel.hidden = true;
      btn.setAttribute("aria-expanded", "false");
    });
  }

  /* ───────────────────────────────────────────
     5. Headline animation
     The old build crossfaded the whole line, which on a dark page
     reads as a flicker and is easy to miss. This rises the words in
     sequence: cheap (one transition per word, no library, no
     measuring) and impossible not to notice out of the corner of
     the eye.
     ─────────────────────────────────────────── */
  function wordLayer(text, cls) {
    var p = D.createElement(cls === "os-coshead__layer" ? "h1" : "p");
    /* os-layer is what the exit animation keys off. Without it the
       rule only existed for two of the five headline classes, and
       the other three left their outgoing line sitting at full
       opacity under the new one until the timeout removed it —
       which reads as the new text landing on top of the old. */
    p.className = cls + " os-layer";
    var words = String(text).split(/\s+/);
    for (var i = 0; i < words.length; i++) {
      var w = D.createElement("span");
      w.className = "os-w";
      w.style.setProperty("--i", i);
      var inner = D.createElement("i");
      inner.textContent = words[i];
      w.appendChild(inner);
      p.appendChild(w);
      if (i < words.length - 1) p.appendChild(D.createTextNode(" "));
    }
    return p;
  }

  function swapHeadline(wrap, text, cls) {
    if (!wrap) return;
    var old = wrap.querySelector("." + cls + ":not(.is-out)");
    if (old && old.textContent.replace(/\s+/g, " ").trim() === String(text).trim()) return;

    var next = wordLayer(text, cls);
    wrap.appendChild(next);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        next.classList.add("is-in");
        if (old) {
          old.classList.add("is-out");
          setTimeout(function () {
            if (old.parentNode) old.parentNode.removeChild(old);
          }, 900);
        }
      });
    });

    /* The accent rule under the headline wipes across on every
       change. One transform, and it is what the eye catches. */
    var rule = wrap.parentNode && wrap.parentNode.querySelector("[data-os-rule]");
    if (rule) {
      rule.classList.remove("is-wipe");
      void rule.offsetWidth;
      rule.classList.add("is-wipe");
    }
  }

  function swapNote(root, text) {
    var el = root.querySelector("[data-os-note]");
    if (!el) return;
    if (el.textContent.trim() === String(text).trim()) return;
    el.classList.add("is-out");
    setTimeout(function () {
      el.textContent = text;
      el.classList.remove("is-out");
    }, 320);
  }

  function fadeSwap(el, fill) {
    if (!el) return;
    el.classList.add("is-out");
    setTimeout(function () {
      fill();
      el.classList.remove("is-out");
    }, 300);
  }

  /* ───────────────────────────────────────────
     6. Catalog
     ─────────────────────────────────────────── */
  function catalog() {
    var raw = D.querySelector("[data-os-catalog]");
    if (!raw) return {};
    try { return JSON.parse(raw.textContent).products || {}; }
    catch (e) { return {}; }
  }

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  /* What each system in "More for you" is, in one line. Devices take
     their line from the deck's GEAR list. */
  var SYSTEM_SAY = {
    "brew-control-ti": "Microbalance Ti and R2 Extract. Dose, yield and extraction on every brew.",
    "sensory-bcs": "Microbalance Ti, R2 Extract, Moment and the Particle Analysis Coaster: the brew, the grind, and Taste by Temperature.",
    "roast-validation-ultimate": "Omix Plus, Microbalance Ti and R2 Extract. The green, the roast and the cup on one record."
  };
  function tileSay(slug) {
    var g = C.HOME && C.HOME.gear && C.HOME.gear[slug];
    if (g && g.line) return g.line;
    return SYSTEM_SAY[slug] ? T("main.system_say." + slug.replace(/-/g, "_"), SYSTEM_SAY[slug]) : "";
  }
  function tile(products, slug, badge, span) {
    var p = products[slug];
    if (!p) return "";
    var say = tileSay(slug);
    var g = C.HOME && C.HOME.gear && C.HOME.gear[slug];
    var name = (g && g.name) || p.name;
    return (
      '<a class="os-tile' + (span ? " os-tile--span" : "") + '" href="' + esc(p.url) +
      '" data-os-door="home">' +
      (badge ? '<span class="os-badge">' + esc(badge) + "</span>" : "") +
      '<img src="' + esc(p.image) + '" alt="" loading="lazy">' +
      '<span class="os-tile__bar os-tile__bar--say"><strong>' + esc(name) + "</strong><b>" +
      esc(p.price) + "</b>" + (say ? '<span class="os-tile__say">' + esc(say) + "</span>" : "") + "</span></a>"
    );
  }

  /* ───────────────────────────────────────────
     7. Home
     ─────────────────────────────────────────── */
  var homePainted = false;


  /* The opening bundle.

     One system, what is in it, and the CoffeeOS tools that work with
     it. It sits between
     the headline and the tiles because the headline makes a claim
     and this is the first thing that pays it off — the version
     without it left "setting 40 here is not setting 40 there"
     hanging over a list of products with no captions.

     Names and lines come from OS_CONTENT.HOME; prices, links and
     photographs from the catalog the section writes; Tool pages
     from OS_TOOL_URLS. */
  function kitHTML(id) {
    var H = C.HOME || {};
    var kit = (H.kit && (H.kit[id] || H.kit[C.FAMILY[id]] || H.kit.roaster)) || null;
    if (!kit) return "";
    var products = catalog();
    var p = products[kit.h];
    if (!p) return "";

    /* Each device drawn beside its name, from OS_GEAR. One without a
       render keeps the picture column empty so the names still line up. */
    var shots = window.OS_GEAR || {};
    var gear = (kit.gear || []).map(function (k) {
      var g = (H.gear || {})[k];
      if (!g) return "";
      var link = products[k];
      var label = link
        ? '<a href="' + esc(link.url) + '">' + esc(g.name) + "</a>"
        : esc(g.name);
      var src = shots[k];
      return '<li>' +
        '<span class="os-kit__dev">' +
          (src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : "") +
        "</span>" +
        "<span><strong>" + label + "</strong><span>" + esc(g.line) + "</span></span>" +
      "</li>";
    }).join("");

    var toolUrls = window.OS_TOOL_URLS || {};
    var tools = (kit.tools || []).map(function (k) {
      var t = (H.tools || {})[k];
      if (!t) return "";
      /* A role's own line for a tool, when that reader uses it for a
         different reason, beats the shared one. */
      var line = (kit.toolLines && kit.toolLines[k]) || t.line;
      var ic = iconUrl(k);
      var url = toolUrls[k];
      var name = url
        ? '<a href="' + esc(url) + '">' + esc(t.name) + "</a>"
        : esc(t.name);
      return '<li>' +
        '<span class="os-kit__ico">' +
          (ic ? '<img src="' + esc(ic) + '" alt="" loading="lazy">' : "") +
        "</span>" +
        "<span><strong>" + name + "</strong><span>" + esc(line) + "</span></span>" +
      "</li>";
    }).join("");

    return (
      '<div class="os-kit__top">' +
        '<a class="os-kit__shot" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
          (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : "") +
        "</a>" +
        '<div class="os-kit__say">' +
          '<p class="os-sectiontitle">' + esc(kit.eyebrow || T("main.recommended_for_you", "Recommended for you")) + "</p>" +
          '<h2><a href="' + esc(p.url) + '">' + esc(p.name) + "</a></h2>" +
          '<p class="os-kit__lead">' + esc(kit.lead) + "</p>" +
          '<p class="os-kit__buy">' +
            "<b>" + esc(p.price) + "</b>" +
            (p.was ? "<s>" + esc(p.was) + "</s>" : "") +
            (p.avail
              ? '<a class="os-kit__go" href="' + esc(p.url) + '">' + esc(T("main.see_whats_in_it", "See what is in it")) + "</a>"
              : '<span class="os-kit__soon">' + esc(T("main.back_soon", "Back soon")) + "</span>") +
          "</p>" +
        "</div>" +
      "</div>" +
      '<div class="os-kit__cols">' +
        (gear ? '<div class="os-kit__col"><p class="os-sectiontitle">' + esc(T("main.in_the_box", "In the box")) + '</p><ul class="os-kit__list os-kit__list--gear">' + gear + "</ul></div>" : "") +
        (tools ? '<div class="os-kit__col"><p class="os-sectiontitle">' + esc(T("main.tools_that_work_with_it", "CoffeeOS Tools that work with it")) + '</p><ul class="os-kit__list os-kit__list--tools">' + tools + "</ul></div>" : "") +
      "</div>"
    );
  }

  function paintKit(root, id) {
    var el = root.querySelector("[data-os-kit]");
    if (!el) return;
    var html = kitHTML(id);
    if (!html) { el.hidden = true; return; }
    el.hidden = false;
    el.innerHTML = html;
  }

  function paintHome(id) {
    var root = D.querySelector("[data-os-home]");
    if (!root) return;
    var products = catalog();
    var head = (C.HOME.head && (C.HOME.head[id] || C.HOME.head.roaster)) || { h: "", n: "" };

    swapHeadline(root.querySelector("[data-os-week]"), head.h, "os-week__layer");
    swapNote(root, head.n);

    var featuredEl = root.querySelector("[data-os-featured]");

    /* "More for you": one grid, three tiles. It used to be a tile
       grid and then a list underneath, and the two overlapped, so the
       same product could appear three times in a row counting the
       recommended system above them. Now the two lists are merged,
       each product appears once, the system already recommended is
       left out, and the first three that exist in the catalog are
       shown. The only badge kept is one that means something to a
       customer ("New"). */
    function moreFor(role) {
      var kit = (C.HOME && C.HOME.kit && (C.HOME.kit[role] || C.HOME.kit.roaster)) || {};
      var seen = {};
      if (kit.h) seen[kit.h] = 1;
      var list = [];
      var feat = FEATURED[role] || FEATURED.roaster;
      var rest = SYSTEMS[role] || SYSTEMS.roaster;
      var all = feat.map(function (r) { return { slug: r[0], badge: r[1] === "New" ? T("main.badge_new", "New") : null }; })
        .concat(rest.map(function (s) { return { slug: s, badge: null }; }));
      for (var i = 0; i < all.length && list.length < 3; i++) {
        var it = all[i];
        if (seen[it.slug] || !products[it.slug]) continue;
        seen[it.slug] = 1;
        list.push(it);
      }
      return list;
    }

    function fill() {
      if (!featuredEl) return;
      var list = moreFor(id);
      featuredEl.innerHTML = list
        .map(function (it, i) { return tile(products, it.slug, it.badge, i === 0); }).join("");
      var wrap = featuredEl.closest ? featuredEl.closest("[data-os-more]") : null;
      if (wrap) wrap.hidden = list.length === 0;
    }

    if (!homePainted) { homePainted = true; paintKit(root, id); fill(); return; }
    fadeSwap(root.querySelector("[data-os-kit]"), function () { paintKit(root, id); });
    fadeSwap(featuredEl, fill);
  }

  /* ───────────────────────────────────────────
     8. Stage pages — Farm, Roast, Brew
     ─────────────────────────────────────────── */
  var stagePainted = {};

  function toolCard(stage, tool, products, id) {
    var p = products[tool.slug];
    var url = p ? p.url : "#";
    var price = p ? p.price : "";
    var img = imgUrl(tool.img);
    var why = C.pick(tool.why, id);

    return (
      '<article class="os-tool">' +
        '<a class="os-tool__shot' + (tool.cut ? " os-tool__shot--cut" : "") +
        '" href="' + esc(url) + '" data-os-door="' + esc(stage.slug) + '">' +
          (img ? '<img src="' + esc(img) + '" alt="' + esc(tool.alt || "") + '" loading="lazy">' : "") +
        "</a>" +
        '<div class="os-tool__body">' +
          '<h3><a href="' + esc(url) + '" data-os-door="' + esc(stage.slug) + '">' + esc(tool.name) + "</a></h3>" +
          '<p class="os-tool__does">' + esc(tool.does) + "</p>" +
          /* Hidden rather than omitted when there is nothing to say
             for this role: the role-swap below pairs these elements
             with stage.tools by index, so the element has to stay.
             Without this the card shows the mint accent rule with no
             sentence beside it. */
          '<p class="os-tool__why" data-os-why' + (why ? "" : " hidden") + ">" +
            esc(why) + "</p>" +
          '<p class="os-tool__foot">' +
            '<span class="os-tool__spec">' + esc(tool.spec || "") + "</span>" +
            (price ? '<b>' + esc(price) + "</b>" : "") +
          "</p>" +
        "</div>" +
      "</article>"
    );
  }

  /* Photographs are rendered by Liquid into a lookup on the page, so
     the same content deck works in the preview and on the store
     without the image paths being written twice. */
  function imgUrl(key) {
    if (!key) return "";
    var map = window.OS_IMAGES || {};
    return map[key] || "";
  }

  /* Room URLs come from Liquid too, so a collection handle can change
     in Shopify without the copy deck knowing about it. */
  function link(key) {
    var map = window.OS_LINKS || {};
    return map[key] || "/" + key;
  }

  /* The parts of a stage page that do not move with the role. Painted
     once, on the first pass. */
  function paintStageChrome(root, stage) {
    var set = function (sel, text) {
      var el = root.querySelector(sel);
      if (el) el.textContent = text;
    };
    set("[data-os-stagetitle]", stage.title);
    set("[data-os-eyebrow]", stage.eyebrow);
    set("[data-os-intro]", stage.intro);

    var band = root.querySelector("[data-os-band]");
    if (band && stage.os) {
      band.hidden = false;
      set("[data-os-band-title]", stage.os.title);
      set("[data-os-band-note]", stage.os.note);
      var shots = root.querySelector("[data-os-band-shots]");
      if (shots) {
        shots.innerHTML = stage.os.shots.map(function (s) {
          var u = imgUrl(s.img);
          if (!u) return "";
          return '<figure class="os-shot"><img src="' + esc(u) +
            '" alt="" loading="lazy"><span>' + esc(s.cap) + "</span></figure>";
        }).join("");
      }
    }

    var learn = root.querySelector("[data-os-learn]");
    if (learn && stage.learn) {
      learn.innerHTML = stage.learn.map(function (l) {
        return '<a href="' + esc(l.url) + '"><strong>' + esc(l.label) +
          "</strong><span>" + esc(l.note) + "</span></a>";
      }).join("");
    }

    var next = root.querySelector("[data-os-next]");
    if (next && stage.next) {
      next.innerHTML = stage.next.map(function (n) {
        var u = imgUrl(n.img);
        return '<a class="os-tile os-door" href="' + esc(link(n.slug)) +
          '" data-os-page="' + esc(n.slug) + '">' +
          (u ? '<img src="' + esc(u) + '" alt="" loading="lazy">' : "") +
          '<span class="os-tile__bar"><strong>' + esc(n.label) +
          "</strong></span></a>";
      }).join("");
    }
  }

  function paintStage(id) {
    var root = D.querySelector("[data-os-stage]");
    if (!root) return;
    var slug = root.getAttribute("data-os-stage");
    var stage = C.STAGES[slug];
    if (!stage) return;

    var products = catalog();
    var head = stage.head[id] || stage.head[C.FAMILY[id]] || stage.head.roaster ||
               stage.head[Object.keys(stage.head)[0]];

    swapHeadline(root.querySelector("[data-os-roomhead]"), head.h, "os-roomhead__layer");
    swapNote(root, head.n);

    var toolsEl = root.querySelector("[data-os-tools]");
    function fill() {
      if (!toolsEl) return;
      toolsEl.innerHTML = stage.tools.map(function (t) {
        return toolCard(stage, t, products, id);
      }).join("");
    }

    if (!stagePainted[slug]) {
      stagePainted[slug] = true;
      paintStageChrome(root, stage);
      fill();
      return;
    }

    /* Only the role-dependent line changes on a role swap, so the
       photographs do not blink. */
    var whys = toolsEl ? toolsEl.querySelectorAll("[data-os-why]") : [];
    for (var i = 0; i < whys.length; i++) {
      (function (el, t, n) {
        setTimeout(function () {
          el.classList.add("is-out");
          setTimeout(function () {
            var txt = C.pick(t.why, id);
            el.textContent = txt;
            el.hidden = !txt;
            el.classList.remove("is-out");
          }, 260);
        }, n * 85);
      })(whys[i], stage.tools[i], i);
    }
  }


  /* ───────────────────────────────────────────
     8b. Learn
     Desktop reads like macOS Tips; on a phone it reads like a screen
     inside CoffeeOS, because that is what it is — the app opens this
     page in a browser window when someone taps Learn.
     ─────────────────────────────────────────── */
  /* Looked up when it is needed, not captured at start-up.
     os-learn.js is loaded by the Learn section now rather than on
     every page, so it can arrive after this file runs. */
  function LIB() { return window.OS_LEARN || null; }
  var learnCat = "all";
  var learnBuilt = false;

  function iconUrl(key) {
    var m = window.OS_ICONS || {};
    return m[key] || "";
  }

  function guideUrl(key) {
    var m = window.OS_GUIDES || {};
    return m[key] || "";
  }

  function learnCard(row, kind) {
    var it = row.item;
    var ready = it.state === "ready" && guideUrl(it.guide);
    var art;

    if (kind === "device") {
      var u = imgUrl(it.img);
      art = '<span class="os-card__art os-card__art--photo">' +
        (u ? '<img src="' + esc(u) + '" alt="" loading="lazy">' : "") + "</span>";
    } else {
      var ic = iconUrl(it.icon);
      art = '<span class="os-card__art">' +
        (ic ? '<img class="os-card__icon" src="' + esc(ic) + '" alt="" loading="lazy">' : "") +
        "</span>";
    }

    return (
      '<article class="os-card' + (row.inBag ? " is-bag" : "") + (ready ? "" : " is-soon") +
        '" data-learn-id="' + esc(it.id) + '" style="--i:' + (row.n || 0) + '">' +
        '<a class="os-card__hit" href="' + esc(ready ? guideUrl(it.guide) : "#") +
          '" data-os-guide="' + esc(ready ? it.guide : "") +
          '" data-guide-title="' + esc(it.title) + '">' +
          art +
          '<span class="os-card__body">' +
            '<strong>' + esc(it.title) + "</strong>" +
            '<span class="os-card__sub">' + esc(it.sub) + "</span>" +
            '<span class="os-card__meta">' +
              (row.inBag ? '<b class="os-chip os-chip--bag">' + esc(T("main.in_your_bag", "In your bag")) + "</b>" : "") +
              (ready ? "" : '<b class="os-chip">' + esc(T("main.coming", "Coming")) + "</b>") +
              (it.meta ? '<i>' + esc(it.meta) + "</i>" : "") +
            "</span>" +
            '<span class="os-card__why" data-os-why-rank></span>' +
          "</span>" +
        "</a>" +
      "</article>"
    );
  }

  /* FLIP. Measure where every card is, re-order, measure again, then
     play the difference back as a transform. The browser only ever
     animates transform and opacity, so a full reshuffle of thirty
     cards costs the same as moving one. */
  function reflow(container, fill) {
    if (!container) { return; }
    var before = {};
    var cards = container.querySelectorAll("[data-learn-id]");
    var i, id, r;
    for (i = 0; i < cards.length; i++) {
      before[cards[i].getAttribute("data-learn-id")] = cards[i].getBoundingClientRect();
    }

    fill();

    var after = container.querySelectorAll("[data-learn-id]");
    for (i = 0; i < after.length; i++) {
      var el = after[i];
      id = el.getAttribute("data-learn-id");
      r = el.getBoundingClientRect();
      var was = before[id];
      if (!was) {
        el.classList.add("is-new");
        continue;
      }
      var dx = was.left - r.left, dy = was.top - r.top;
      if (!dx && !dy) continue;
      el.style.transition = "none";
      el.style.transform = "translate(" + dx + "px," + dy + "px)";
      el.setAttribute("data-flip", "1");
    }

    requestAnimationFrame(function () {
      var moved = container.querySelectorAll("[data-flip]");
      for (var j = 0; j < moved.length; j++) {
        moved[j].style.transition = "";
        moved[j].classList.add("is-sliding");
        moved[j].style.transform = "";
        moved[j].removeAttribute("data-flip");
      }
      var fresh = container.querySelectorAll(".is-new");
      for (var k = 0; k < fresh.length; k++) fresh[k].classList.remove("is-new");
      setTimeout(function () {
        var s2 = container.querySelectorAll(".is-sliding");
        for (var m = 0; m < s2.length; m++) s2[m].classList.remove("is-sliding");
      }, 780);
    });
  }

  function paintLearnList(sel, kind, id, opts) {
    var box = D.querySelector(sel);
    var L = LIB();
    if (!box || !L) return;
    reflow(box, function () {
      var rows = L.rank(kind, id, opts || {});
      rows.forEach(function (r, n) { r.n = n; });
      box.innerHTML = rows.map(function (r) { return learnCard(r, kind); }).join("");
      if (D.body.classList.contains("os-explain")) {
        var whys = box.querySelectorAll("[data-os-why-rank]");
        for (var i = 0; i < whys.length; i++) {
          whys[i].textContent = L.explain(rows[i].item, id);
        }
      }
    });
  }

  function paintLearn(id) {
    var root = D.querySelector("[data-os-learn-page]");
    var L = LIB();
    if (!root || !L) return;

    if (!learnBuilt) {
      learnBuilt = true;
      var chips = root.querySelector("[data-os-learncats]");
      if (chips) {
        chips.innerHTML = L.cats().map(function (c) {
          return '<button type="button" class="os-chipbtn' +
            (c.id === learnCat ? " is-on" : "") + '" data-cat="' + c.id + '">' +
            esc(c.label) + "</button>";
        }).join("");
        chips.addEventListener("click", function (e) {
          var b = e.target.closest("[data-cat]");
          if (!b) return;
          learnCat = b.getAttribute("data-cat");
          var all = chips.querySelectorAll("[data-cat]");
          for (var i = 0; i < all.length; i++) {
            all[i].classList.toggle("is-on", all[i] === b);
          }
          paintLearnList("[data-os-tools-list]", "tool", currentId(), { cat: learnCat });
        });
      }
    }

    swapHeadline(root.querySelector("[data-os-learnhead]"), learnHead(id), "os-learnhead__layer");

    /* The three quick answers at the top are the highest-scoring
       things overall, whatever kind they are. */
    var quick = root.querySelector("[data-os-quick]");
    if (quick) {
      reflow(quick, function () {
        var L = LIB();
        var pool = L.rank("tool", id).concat(L.rank("course", id));
        pool.sort(function (a, b) {
          if (a.inBag !== b.inBag) return a.inBag ? -1 : 1;
          return b.s - a.s;
        });
        /* One entry per topic. The course and the tool guide for
           roast color are the same answer twice. */
        var seenGuide = {}, top = [];
        for (var pi = 0; pi < pool.length && top.length < 3; pi++) {
          var key = pool[pi].item.guide || pool[pi].item.id;
          if (seenGuide[key]) continue;
          seenGuide[key] = 1;
          top.push(pool[pi]);
        }
        quick.innerHTML = top.map(function (r) {
          var it = r.item, ready = it.state === "ready" && guideUrl(it.guide);
          return '<a data-learn-id="q-' + esc(it.id) + '" href="' +
            esc(ready ? guideUrl(it.guide) : "#") + '" data-os-guide="' +
            esc(ready ? it.guide : "") + '" data-guide-title="' + esc(it.title) + '">' +
            '<img src="' + esc(iconUrl(it.icon)) + '" alt="">' +
            '<span><strong>' + esc(it.title) + "</strong><span>" + esc(it.sub) + "</span></span></a>";
        }).join("");
      });
    }

    paintLearnList("[data-os-courses]", "course", id);
    paintLearnList("[data-os-tools-list]", "tool", id, { cat: learnCat });
    paintLearnList("[data-os-devices]", "device", id);
  }

  var LEARN_HEAD = {
    producer: "Learn what moisture and water activity mean for your lot.",
    exporter: "Learn to send a reading, not an adjective.",
    importer: "Learn to check an offer against its paperwork.",
    q: "Learn how moisture, water activity and density are measured.",
    roaster: "Learn to repeat a roast on purpose.",
    cafe: "Learn to make yesterday's cup again.",
    hobby: "Learn what your grinder is actually doing.",
    home: "Learn to roast by measurement, not by ear.",
    educator: "Learn it, then teach it from your students' own records.",
    competitor: "Learn to do it the same way twice, on the day."
  };
  function learnHead(id) {
    var ov = window.OS_LEARN_HEAD || {};
    function deck(k) { return LEARN_HEAD[k] ? T("main.learn_head." + k, LEARN_HEAD[k]) : ""; }
    return ov[id] || deck(id) || ov.roaster || deck("roaster");
  }


  /* ───────────────────────────────────────────
     8c. CoffeeOS
     The overview page. It carries no detail of its own — every Tool
     links out to its own page, and the interactive tutorial is your
     existing CoffeeOS Intro, rendered inline rather than rebuilt.
     ─────────────────────────────────────────── */
  var cosBuilt = false;

  function toolBase() {
    var root = D.querySelector("[data-os-coffeeos]");
    var b = root && root.getAttribute("data-tool-base");
    return (b || "/pages/coffeeos").replace(/\/+$/, "");
  }

  function toolById(id) {
    var L = LIB();
    if (!L) return null;
    for (var i = 0; i < L.ITEMS.length; i++) {
      if (L.ITEMS[i].id === id) return L.ITEMS[i];
    }
    return null;
  }

  /* The narrative acts. Each one is a headline and a paragraph
     picked by role family, so the spine of the page holds still
     while the argument re-points at whoever is reading it. */
  function paintActs(root, id) {
    var acts = C.COFFEEOS && C.COFFEEOS.acts;
    if (!acts) return;
    [].forEach.call(root.querySelectorAll("[data-os-act]"), function (sec) {
      var a = acts[sec.getAttribute("data-os-act")];
      if (!a) return;
      var h = sec.querySelector("[data-act-h]");
      var b = sec.querySelector("[data-act-b]");
      var e = sec.querySelector("[data-act-eyebrow]");
      if (e) { e.textContent = a.eyebrow || ""; e.hidden = !a.eyebrow; }

      /* The Tool this chapter is about, with its own icon, so the
         reader can place the section inside the app before reading
         a word of it. Links to that Tool's page when it has one;
         a chapter that belongs to no single Tool — the Tools page
         itself, sharing — shows the CoffeeOS mark instead. */
      var mark = sec.querySelector("[data-act-tool]");
      /* A marker is either one object for everybody, or keyed by
         family the way h and b are. A chapter about a behavior
         rather than about a Tool — how a field fills — has to name
         a different Tool per reader, because they do not all fill
         the same one. Told apart by whether it carries a name. */
      var tool = (a.tool && !a.tool.name) ? C.pick(a.tool, id) : a.tool;
      if (mark && !tool) { mark.innerHTML = ""; mark.removeAttribute("href"); }
      if (mark && tool && tool.name) {
        var icons = window.OS_ICONS || {};
        /* A device rather than a Tool (Moment) shows its render. */
        var src = tool.gear ? (window.OS_GEAR || {})[tool.gear] || "" :
          (tool.icon ? icons[tool.icon] : "");
        if (!src) src = mark.getAttribute("data-app-icon") || "";
        var urls = window.OS_TOOL_URLS || {};
        var href = tool.icon ? urls[tool.icon] : "";
        mark.innerHTML =
          (src ? '<img src="' + esc(src) + '" alt="" width="34" height="34">' : "") +
          "<span><strong>" + esc(tool.name) + "</strong>" +
          "<span>" + esc(tool.sub || "") + "</span></span>";
        if (href) {
          mark.setAttribute("href", href);
          mark.classList.add("is-link");
        } else {
          mark.removeAttribute("href");
          mark.classList.remove("is-link");
        }
      }

      /* The photograph in the chapter, where it also moves with the
         reader. Whole URLs come from Shopify in window.OS_ACTSHOT,
         keyed act → family; the copy deck only names which one. */
      var fig = sec.querySelector("[data-act-shot]");
      if (fig && a.shot) {
        var s = C.pick(a.shot, id);
        var urlmap = (window.OS_ACTSHOT || {})[sec.getAttribute("data-os-act")] || {};
        var u = s && (urlmap[s.img] || null);
        var im = fig.querySelector("img");
        var cp = fig.querySelector("figcaption");
        /* src alone does not change what is drawn. The <img> carries a
           srcset, and a srcset with a usable candidate wins over src —
           so the first photograph stayed on screen through every
           persona while the attribute underneath it said otherwise.
           Both go, or the swap is decorative. */
        if (im && u && u.m && im.getAttribute("src") !== u.m) {
          im.setAttribute("srcset", u.s + " 800w, " + u.m + " 1200w, " + u.l + " 1600w");
          im.setAttribute("src", u.m);
          im.setAttribute("alt", s.alt || "");
        } else if (im && !u && window.console) {
          console.warn("[OS] act shot missing:", sec.getAttribute("data-os-act"), s && s.img);
        }
        if (cp) { cp.textContent = (s && s.cap) || ""; cp.hidden = !(s && s.cap); }
      }

      /* Which illustration this chapter shows. Kept in step with the
         marker and the photograph above, so a reader never gets one
         Tool named, a second photographed and a third to play with. */
      if (a.scene) {
        var want = C.pick(a.scene, id);
        [].forEach.call(sec.querySelectorAll("[data-act-scene]"), function (el) {
          el.hidden = el.getAttribute("data-act-scene") !== want;
        });
      }

      if (h) swapHeadline(h, C.pick(a.h, id), "os-acth__layer");
      if (b) {
        var txt = C.pick(a.b, id);
        if (b.textContent.trim() === txt) return;
        b.classList.add("is-out");
        setTimeout(function () {
          b.textContent = txt;
          b.classList.remove("is-out");
        }, 200);
      }
    });
  }

  /* The running order. Chapters are flex children of .os-acts, so
     re-ordering is a CSS `order` change rather than moving nodes —
     which keeps any iframe inside a chapter alive. Moving an iframe
     in the DOM reloads it, and reloading a simulator someone is
     halfway through using would be its own small betrayal. */
  /* The opening photograph. A bed of coffee cherries is the right
     first image for a producer and meaningless to someone who only
     brews, so the hero swaps with the role. Crossfaded rather than
     switched, because the hero is the first thing on screen and a
     hard cut there reads as a reload. */
  function paintHero(root, id) {
    var hero = root.querySelector("[data-os-hero]");
    var map = window.OS_HERO;
    if (!hero || !map) return;

    /* Whole URLs, asked of Shopify one file at a time in the section.
       The previous version pasted a file name onto a base path, which
       produced a 404 — and because the swap waited on the image's
       onload, the failure was completely silent: the hero simply
       never changed for anyone. Anything that can fail quietly gets
       a console line now. */
    /* Each role now carries two files. A phone took the same 1600px
       hero a desktop did, which is most of a megabyte for a picture
       shown 390 pixels wide. Chosen once, on the width at paint. */
    var entry = map[id] || map["default"];
    if (!entry) return;
    var small = window.innerWidth <= 700;
    var url = typeof entry === "string" ? entry : (small ? entry.s : entry.l);
    if (!url) return;
    if (hero.dataset.shot === url) return;
    hero.dataset.shot = url;

    var img = new Image();
    img.onload = function () {
      hero.classList.add("is-swapping");
      setTimeout(function () {
        hero.style.setProperty("--shot", "url('" + url + "')");
        hero.classList.remove("is-swapping");
      }, 200);
    };
    img.onerror = function () {
      if (window.console) console.warn("[OS] hero image missing:", url);
      hero.dataset.shot = "";
    };
    img.src = url;
  }

  function orderChapters(root, id) {
    var K = C.COFFEEOS;
    if (!K || !K.order) return;
    var seq = C.pick(K.order, id) || K.order.default;

    /* A chapter not in this reader's list is not shown to them. */
    [].forEach.call(root.querySelectorAll("[data-os-act]"), function (sec) {
      var i = seq.indexOf(sec.getAttribute("data-os-act"));
      if (sec.hasAttribute("data-os-fixed")) return;
      sec.hidden = i < 0;
      if (i >= 0) sec.style.order = i;
    });
  }

  function paintCoffeeOS(id) {
    var root = D.querySelector("[data-os-coffeeos]");
    if (!root || !C.COFFEEOS) return;
    var K = C.COFFEEOS;
    var base = toolBase();

    paintActs(root, id);
    orderChapters(root, id);
    paintHero(root, id);

    var head = K.head[id] || K.head.roaster;
    swapHeadline(root.querySelector("[data-os-coshead]"), head.h, "os-coshead__layer");
    swapNote(root, head.n);

    /* Every Tool, ordered by the same ranker the Learn page uses, so a
       reader meets them in the same order in both places. Icon and
       name only: each tile links to that Tool's own page. */
    var grid = root.querySelector("[data-os-cotools]");
    if (grid && LIB()) {
      reflow(grid, function () {
        var L = LIB();
        var rows = L.rank("tool", id);
        grid.innerHTML = rows.map(function (r, n) {
          var t = r.item;
          var map = window.OS_TOOL_URLS || {};
          var href = map[t.handle] || "";
          var tag = href ? "a" : "div";
          return "<" + tag + ' class="os-cotool' + (href ? "" : " is-soon") +
            '" data-learn-id="cos-' + esc(t.id) + '"' +
            (href ? ' href="' + esc(href) + '"' : "") +
            ' style="--i:' + n + '">' +
            '<img src="' + esc(iconUrl(t.icon)) + '" alt="" loading="lazy">' +
            "<strong>" + esc(t.title) + "</strong>" +
            (r.inBag ? '<b class="os-chip os-chip--bag">' + esc(T("main.in_your_bag", "In your bag")) + "</b>" : "") +
            "</" + tag + ">";
        }).join("");
      });
    }

    if (cosBuilt) return;
    cosBuilt = true;

    /* Fixed furniture, painted once. */
    var setText = function (sel, txt) {
      var el = root.querySelector(sel);
      if (el) el.textContent = txt || "";
    };
    var list = function (sel, items) {
      var el = root.querySelector(sel);
      if (el) el.innerHTML = (items || []).map(function (t) { return "<li>" + esc(t) + "</li>"; }).join("");
    };
    if (K.about) {
      setText("[data-os-about-sub]", K.about.sub);
      setText("[data-os-about-h]", K.about.h);
      setText("[data-os-about-b]", K.about.b);
      setText("[data-os-about-tools]", K.about.toolsTitle);
    }
    setText("[data-os-heronote]", K.hero_note);
    setText("[data-os-heromore]", K.hero_more);
    if (K.tryBrew) {
      setText("[data-os-trybrew-h]", K.tryBrew.h);
      setText("[data-os-trybrew-b]", K.tryBrew.b);
      list("[data-os-trybrew-how]", K.tryBrew.how);
    }
    if (K.tryRatio) {
      setText("[data-os-tryratio-h]", K.tryRatio.h);
      setText("[data-os-tryratio-b]", K.tryRatio.b);
      list("[data-os-tryratio-how]", K.tryRatio.how);
    }
    if (K.tryMoment) {
      list("[data-os-trymoment-how]", K.tryMoment.how);
      setText("[data-os-trymoment-more]", K.tryMoment.more);
    }
    if (K.free) {
      setText("[data-os-free-h]", K.free.h);
      setText("[data-os-free-b]", K.free.b);
      setText("[data-os-free-devices]", K.free.devicesTitle);
    }

    var flow = root.querySelector("[data-os-coflow]");
    if (flow && K.how) {
      setText("[data-os-how-h]", K.how.h);
      flow.innerHTML = K.how.steps.map(function (f) {
        return '<li><b>' + esc(f.n) + "</b><div><strong>" + esc(f.t) +
          "</strong><span>" + esc(f.b) + "</span></div></li>";
      }).join("");
    }

    var devs = root.querySelector("[data-os-codevices]");
    if (devs) {
      var products = catalog();
      var gear = window.OS_GEAR || {};
      devs.innerHTML = K.devices.map(function (d) {
        var pr = products[d.slug];
        if (!pr) return "";
        var img = gear[d.slug] || pr.image;
        return '<a class="os-codev" href="' + esc(pr.url) + '" data-os-door="coffeeos">' +
          '<img src="' + esc(img) + '" alt="" loading="lazy">' +
          "<span><strong>" + esc(pr.name) + "</strong><span>" +
          esc(d.use) + "</span></span></a>";
      }).join("");
    }

    var close = root.querySelector("[data-os-coclose]");
    if (close) {
      close.innerHTML = "<h2>" + esc(K.close.h) + "</h2><p>" + esc(K.close.b) + "</p>";
    }
  }

  /* A role change on the CoffeeOS page is not a text swap — the
     chapters come back in a different order and the opening
     photograph changes too. Re-ordering under someone's scroll
     position is disorienting, so the page is carried back to the top
     first and rebuilt while it is out of sight.

     The scroll is animated here rather than handed to
     scrollTo({behavior:'smooth'}), because the browser's own smooth
     scroll has a duration that depends on distance and that nothing
     can read. Measured from 2600px it took about 1.2 seconds, while
     the rebuild was firing on a 340ms timer — so the content faded
     back in at roughly 970px and then kept flying. That race is what
     made it feel awkward. Owning the scroll means the rebuild can
     happen exactly when the page lands.

     It goes to the very top, not to the top of the section: the hero
     is part of what changed, and the sticky header is 65px tall, so
     stopping at the section left the new photograph half covered. */
  function glideTo(y, ms, done) {
    var root = D.documentElement;
    var from = window.pageYOffset;
    var dist = y - from;
    if (Math.abs(dist) < 4 || REDUCED_MOTION || ms <= 0) {
      window.scrollTo(0, y);
      done();
      return;
    }
    /* A page-level scroll-behavior: smooth would fight this loop. */
    var prev = root.style.scrollBehavior;
    root.style.scrollBehavior = "auto";

    var t0 = null;
    function frame(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / ms);
      /* ease-in-out cubic: leaves and arrives calmly, covers the
         middle quickly, which is what stops a long scroll dragging */
      var e = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      window.scrollTo(0, from + dist * e);
      if (p < 1) requestAnimationFrame(frame);
      else {
        root.style.scrollBehavior = prev;
        done();
      }
    }
    requestAnimationFrame(frame);
  }

  /* Bringing the chapters back after a role change.
     .os-acts.is-reflow is opacity: 0, so while that class is on there
     is nothing under the hero but black. It used to come off inside
     two nested animation frames, which is fine right up until no
     frame is drawn — a background tab, a browser throttling rAF, a
     phone that has gone to sleep mid-change. Then the class stays on
     and the page is left blank until it is reloaded.

     Nothing that hides content should depend on a frame callback, so
     the class now comes off whichever of three things happens first:
     the frame, a timer, or the page becoming visible again. Removing
     a class that is already gone costs nothing. */
  function unveil(acts) {
    if (!acts) return;
    acts.classList.remove("is-reflow");
  }

  function changeRole(id) {
    var cos = D.querySelector("[data-os-coffeeos]");
    var acts = cos && cos.querySelector(".os-acts");
    if (!cos || !acts || REDUCED_MOTION) { repaint(id); return; }

    /* A page that is not being drawn cannot animate anyway, and it is
       exactly where the old version stranded itself. Repaint flat. */
    if (D.hidden) { unveil(acts); repaint(id); return; }

    acts.classList.add("is-reflow");
    /* Whatever else happens, the chapters come back. */
    var safety = setTimeout(function () { unveil(acts); }, 1200);

    function finish() {
      clearTimeout(safety);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { unveil(acts); });
      });
      /* And again on a timer, in case those frames never arrive. */
      setTimeout(function () { unveil(acts); }, 60);
    }

    /* Long enough to read as travel, short enough not to be a wait.
       Scaled by distance so a small move is not slowed to match a
       big one. */
    var dist = window.pageYOffset;
    var ms = dist < 40 ? 0 : Math.max(300, Math.min(680, dist * 0.4));

    /* The fade out is 180ms; start the scroll under it rather than
       after it, so the two read as one movement. */
    setTimeout(function () {
      glideTo(0, ms, function () { repaint(id); finish(); });
    }, 120);
  }

  /* Coming back to a tab that was left mid-change. */
  D.addEventListener("visibilitychange", function () {
    if (D.hidden) return;
    var stuck = D.querySelector(".os-acts.is-reflow");
    if (stuck) unveil(stuck);
  });

  function repaint(id) {
    paintHome(id);
    paintStage(id);
    paintLearn(id);
    paintCoffeeOS(id);
    /* Anything else on the page that redraws itself on a role
       change listens for this rather than being wired in here. */
    D.dispatchEvent(new CustomEvent("os:role", { detail: { role: id } }));
  }

  /* ───────────────────────────────────────────
     8b. The download button

     One button, three destinations. A reader on a phone should
     land in the store they can actually install from; a reader
     on a desktop gets the page that offers both, because sending
     them to an iOS store listing on a laptop is a dead end.
     ─────────────────────────────────────────── */
  function paintStoreLinks() {
    var ua = navigator.userAgent || "";
    /* iPadOS reports itself as a Mac, so the touch count is what
       separates an iPad from a laptop. */
    var ios = /iPhone|iPad|iPod/.test(ua) ||
      (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
    var android = /Android/.test(ua) && !/Windows Phone/.test(ua);

    [].forEach.call(D.querySelectorAll("[data-os-store]"), function (a) {
      var d = a.dataset;
      var url = ios ? d.ios : android ? d.android : d.both;
      var label = ios ? T("main.store_ios", "Download on the App Store")
        : android ? T("main.store_android", "Get it on Google Play")
        : (a.getAttribute("data-label-desktop") || T("main.store_desktop", "Get CoffeeOS"));
      if (url) a.setAttribute("href", url);
      var span = a.querySelector("[data-store-label]");
      if (span) span.textContent = label;
      a.setAttribute("data-platform", ios ? "ios" : android ? "android" : "desktop");
    });
  }

  /* ───────────────────────────────────────────
     9. Doors, nav marking, mobile chrome
     ─────────────────────────────────────────── */
  function doorFromPath() {
    var p = location.pathname.toLowerCase();
    if (p.indexOf("farm") !== -1) return "farm";
    if (p.indexOf("roast") !== -1) return "roast";
    if (p.indexOf("brew") !== -1) return "brew";
    if (p.indexOf("system") !== -1 || p.indexOf("bundle") !== -1) return "systems";
    return "home";
  }

  function markDoor(door) {
    fetch(osRoot() + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: { os_door: door || doorFromPath(), persona: currentId() }
      })
    }).catch(function () {});
  }

  function markNav() {
    var path = location.pathname.replace(/\/+$/, "") || "/";
    var links = D.querySelectorAll(".os-sidebar a, .os-tabs a, .os-more a");
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute("href") || "";
      if (/^https?:/i.test(href)) continue;
      href = href.split("?")[0].replace(/\/+$/, "") || "/";
      var hit = href === "/" ? path === "/" : (path === href || path.indexOf(href + "/") === 0);
      if (hit) a.classList.add("is-on");
    }
    /* The Stages tab is a button, not a link: it is lit when the page is
       one of the three stages in its panel. */
    var stagesBtn = D.querySelector("[data-os-stagesbtn]");
    if (stagesBtn && D.querySelector(".os-tabs__panel a.is-on")) stagesBtn.classList.add("is-on");
  }


  function bindSearch() {
    var header = D.querySelector(".os-header");
    if (!header) return;
    var btn = header.querySelector("[data-os-searchbtn]");
    var form = header.querySelector(".os-header__search");
    if (!btn || !form) return;
    var input = form.querySelector("input[type='search'], input[type='text']");

    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = !header.classList.contains("is-searching");
      header.classList.toggle("is-searching", open);
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      if (open && input) input.focus();
    });

    D.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      header.classList.remove("is-searching");
      btn.setAttribute("aria-expanded", "false");
    });

    D.addEventListener("click", function (e) {
      if (header.contains(e.target)) return;
      if (input && input.value) return;
      header.classList.remove("is-searching");
      btn.setAttribute("aria-expanded", "false");
    });
  }


  /* On a phone the tour is not a thing embedded in a page — it is the
     app, opened over the top of it, with a Back button. On desktop it
     just sits inline and none of this runs. */
  function bindTour() {
    var tour = D.querySelector("[data-os-tour]");
    var open = D.querySelector("[data-os-tourbtn]");
    var back = D.querySelector("[data-os-tourback]");
    if (!tour || !open) return;

    function show() {
      tour.classList.add("is-open");
      D.body.classList.add("os-locked");
      open.setAttribute("aria-expanded", "true");
      if (back) back.focus();
    }
    function hide() {
      tour.classList.remove("is-open");
      D.body.classList.remove("os-locked");
      open.setAttribute("aria-expanded", "false");
      open.focus();
    }

    open.addEventListener("click", function (e) { e.preventDefault(); show(); });
    if (back) back.addEventListener("click", function (e) { e.preventDefault(); hide(); });
    D.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && tour.classList.contains("is-open")) hide();
    });

    /* The phone Back button closes the tour instead of leaving the
       page, which is what Back means once it is full screen. */
    window.addEventListener("popstate", function () {
      if (tour.classList.contains("is-open")) hide();
    });
    open.addEventListener("click", function () {
      try { history.pushState({ osTour: 1 }, ""); } catch (e) {}
    });
  }

  function bindMore() {
    var sheet = D.querySelector(".os-more");
    var btn = D.querySelector("[data-os-morebtn]");
    if (!sheet || !btn) return;
    var scrim = sheet.querySelector(".os-more__scrim");

    function open() {
      sheet.setAttribute("data-open", "true");
      D.body.classList.add("os-locked");
      btn.setAttribute("aria-expanded", "true");
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { sheet.classList.add("is-in"); });
      });
    }
    function close() {
      sheet.classList.remove("is-in");
      btn.setAttribute("aria-expanded", "false");
      D.body.classList.remove("os-locked");
      setTimeout(function () {
        if (!sheet.classList.contains("is-in")) sheet.setAttribute("data-open", "false");
      }, 300);
    }

    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      if (sheet.getAttribute("data-open") === "true") close(); else open();
    });
    if (scrim) scrim.addEventListener("click", close);
    D.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
    sheet.addEventListener("click", function (e) { if (e.target.closest("a")) close(); });
  }

  /* Phones: hide the header while scrolling down, bring it back the
     moment the reader scrolls up. It never hides near the top of the
     page, nor while anything that belongs to it is open: search, the
     "I am a" menu, a sheet or the currency panel. Read once per frame. */
  function bindHeadHide() {
    var header = D.querySelector(".os-header");
    if (!header || !window.requestAnimationFrame) return;
    var root = D.documentElement;
    var mq = window.matchMedia ? window.matchMedia("(max-width: 767px)") : null;
    var lastY = window.scrollY || 0;
    var down = 0;
    var ticking = false;

    function busy() {
      if (header.classList.contains("is-searching")) return true;
      if (D.body.classList.contains("os-locked")) return true;
      var menu = header.querySelector("[data-os-menu]");
      if (menu && !menu.hidden) return true;
      if (header.contains(D.activeElement) && D.activeElement.tagName === "INPUT") return true;
      return false;
    }
    function set(hidden) {
      if (root.classList.contains("os-head-hidden") === hidden) return;
      root.classList.toggle("os-head-hidden", hidden);
    }
    function update() {
      ticking = false;
      var y = Math.max(0, window.scrollY || 0);
      var dy = y - lastY;
      lastY = y;
      if ((mq && !mq.matches) || busy() || y < header.offsetHeight * 2) {
        down = 0;
        set(false);
        return;
      }
      if (dy < 0) { down = 0; set(false); return; }   /* any move up: back at once */
      down += dy;
      if (down > 12) set(true);                     /* a deliberate move down: away */
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    if (mq && mq.addEventListener) mq.addEventListener("change", function () { set(false); });
    /* Tabbing into the header shows it. */
    header.addEventListener("focusin", function () { set(false); });
  }

  /* Stages on a phone. The tab bar expands like the Tool Controller:
     the bottom edge stays put and the height runs from the bar's
     collapsed height to the expanded one in one motion (os.css holds
     the timing). Ways out: a stage, a tap outside the lens, the
     handle dragged down, the window, Escape, or the screen growing
     past 768. */
  function bindStages() {
    var bar = D.querySelector("[data-os-tabs]");
    var btn = D.querySelector("[data-os-stagesbtn]");
    var box = D.querySelector("[data-os-stages]");
    if (!bar || !btn || !box) return;
    var catcher = D.querySelector("[data-os-tabs-catch]");
    var win = box.querySelector("[data-os-stages-close]");
    var grip = bar.querySelector("[data-os-tabs-grip]");
    var row = bar.querySelector(".os-tabs__row");
    var timer = 0;

    function isOpen() { return bar.getAttribute("data-state") === "expanded"; }
    function settle() {
      clearTimeout(timer);
      timer = setTimeout(function () { bar.style.height = ""; }, REDUCED_MOTION ? 0 : 340);
    }
    /* Measure the end height with transitions off (the padding and the
       sides change too), put the start back, then let it run. */
    function swap(state) {
      var was = bar.getAttribute("data-state");
      var from = bar.offsetHeight;
      bar.style.transition = "none";
      bar.style.height = "";
      bar.setAttribute("data-state", state);
      var to = bar.offsetHeight;
      if (REDUCED_MOTION) { bar.style.transition = ""; return; }
      bar.setAttribute("data-state", was);
      bar.style.height = from + "px";
      void bar.offsetHeight;
      bar.style.transition = "";
      bar.setAttribute("data-state", state);
      bar.style.height = to + "px";
      settle();
    }
    function open() {
      if (isOpen()) return;
      swap("expanded");
      btn.setAttribute("aria-expanded", "true");
      if (row) row.setAttribute("inert", "");
      box.removeAttribute("inert");
      if (catcher) catcher.classList.add("is-on");
      if (win) win.focus({ preventScroll: true });
    }
    function close(back) {
      if (!isOpen()) return;
      swap("collapsed");
      btn.setAttribute("aria-expanded", "false");
      box.setAttribute("inert", "");
      if (row) row.removeAttribute("inert");
      if (catcher) catcher.classList.remove("is-on");
      if (back) btn.focus({ preventScroll: true });
    }
    box.setAttribute("inert", "");

    btn.addEventListener("click", function (e) { e.stopPropagation(); open(); });
    if (win) win.addEventListener("click", function () { close(true); });
    if (catcher) catcher.addEventListener("click", function () { close(false); });
    box.addEventListener("click", function (e) { if (e.target.closest("a")) close(false); });
    D.addEventListener("keydown", function (e) { if (e.key === "Escape" && isOpen()) close(true); });
    var mq = window.matchMedia && window.matchMedia("(min-width: 768px)");
    if (mq && mq.addEventListener) mq.addEventListener("change", function (m) { if (m.matches) close(false); });

    /* The handle: drag down past 30 px to collapse. */
    if (grip) {
      var y0 = null;
      grip.addEventListener("pointerdown", function (e) {
        if (!isOpen()) return;
        y0 = e.clientY;
        try { grip.setPointerCapture(e.pointerId); } catch (err) {}
      });
      grip.addEventListener("pointerup", function (e) {
        if (y0 === null) return;
        var dy = e.clientY - y0;
        y0 = null;
        if (dy > 30) close(false);
      });
      grip.addEventListener("pointercancel", function () { y0 = null; });
    }
  }

  /* Country and language. snippets/os-region.liquid prints the panel
     once and a button for it in the rail and in the More sheet. Every
     row is a submit button on Shopify's own localization form, so the
     panel works without this; this only opens it, closes it, filters
     the country list, and marks the row that was pressed. */
  function bindRegion() {
    var box = D.getElementById("os-region");
    if (!box) return;
    var panel = box.querySelector(".os-region__panel");
    var find = box.querySelector("[data-os-region-find]");
    var none = box.querySelector("[data-os-region-none]");
    var rows = box.querySelectorAll("[data-os-region-countries] .os-region__row");
    var opener = null;

    /* Views. The first one shows the current currency and the current
       language side by side; each opens its own list, and the row at the
       top of that list comes back. A store with only one of the two goes
       straight to its list. */
    var views = box.querySelectorAll("[data-os-region-view]");
    var root = box.querySelector('[data-os-region-view="root"]');
    var lists = box.querySelectorAll('[data-os-region-view]:not([data-os-region-view="root"])');
    var body = box.querySelector(".os-region__body");
    var home = (root && lists.length > 1) ? "root" : (lists[0] && lists[0].getAttribute("data-os-region-view"));
    box.classList.add("is-js");
    if (root) root.hidden = false;
    box.querySelectorAll(".os-region__back").forEach(function (b) { b.hidden = lists.length < 2; });

    function show(name, focusIt) {
      var target = null;
      views.forEach(function (v) {
        var on = v.getAttribute("data-os-region-view") === name;
        v.classList.toggle("is-shown", on);
        if (on) target = v;
      });
      if (body) body.scrollTop = 0;
      if (find && name !== "country") { find.value = ""; find.dispatchEvent(new Event("input")); }
      if (target && name !== "root" && box.getAttribute("data-open") === "true") {
        var cur = target.querySelector('[aria-current="true"]');
        if (cur && cur.scrollIntoView) cur.scrollIntoView({ block: "nearest" });
      }
      if (focusIt && target) {
        var f = target.querySelector("button:not([hidden]), input");
        if (f) f.focus({ preventScroll: true });
      }
    }
    show(home, false);

    function open(from) {
      opener = from || null;
      /* Coming from the More sheet: that sheet steps aside first, so two
         blocking layers are never stacked. */
      var more = D.querySelector(".os-more");
      if (more && more.getAttribute("data-open") === "true") {
        var ms = more.querySelector(".os-more__scrim");
        if (ms) ms.click();
      }
      show(home, false);
      box.setAttribute("data-open", "true");
      D.body.classList.add("os-locked");
      D.querySelectorAll("[data-os-region-open]").forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          box.classList.add("is-in");
          var cur = box.querySelector('.os-region__row[aria-current="true"]');
          var first = box.querySelector(".os-region__x");
          if (first) first.focus({ preventScroll: true });
          if (cur && cur.scrollIntoView) cur.scrollIntoView({ block: "nearest" });
        });
      });
    }
    function close() {
      if (box.getAttribute("data-open") !== "true") return;
      box.classList.remove("is-in");
      D.body.classList.remove("os-locked");
      D.querySelectorAll("[data-os-region-open]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
      setTimeout(function () {
        if (!box.classList.contains("is-in")) box.setAttribute("data-open", "false");
      }, 300);
      if (opener && opener.focus && opener.offsetParent !== null) opener.focus({ preventScroll: true });
    }

    D.addEventListener("click", function (e) {
      var b = e.target.closest("[data-os-region-open]");
      if (b) { e.preventDefault(); e.stopPropagation(); open(b); return; }
      if (e.target.closest("[data-os-region-close]")) close();
      var go = e.target.closest("[data-os-region-go]");
      if (go && box.contains(go)) show(go.getAttribute("data-os-region-go"), true);
    });
    D.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
      /* Keep Tab inside the panel while it is open. */
      if (e.key === "Tab" && box.getAttribute("data-open") === "true" && panel) {
        var f = panel.querySelectorAll("button:not([hidden]), input");
        if (!f.length) return;
        var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && D.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && D.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    });

    /* The pressed row dims while Shopify reloads the page in the new
       country or language. */
    box.addEventListener("click", function (e) {
      var r = e.target.closest(".os-region__row");
      if (r) r.classList.add("is-going");
    });

    if (find) {
      find.addEventListener("input", function () {
        var q = find.value.trim().toLowerCase();
        var shown = 0;
        rows.forEach(function (r) {
          var hit = !q || (r.getAttribute("data-name") || "").indexOf(q) !== -1;
          r.hidden = !hit;
          if (hit) shown++;
        });
        if (none) none.hidden = shown !== 0;
      });
      /* Enter in the search picks the first match instead of submitting
         the form with no country chosen. */
      find.addEventListener("keydown", function (e) {
        if (e.key !== "Enter") return;
        e.preventDefault();
        for (var i = 0; i < rows.length; i++) {
          if (!rows[i].hidden) { rows[i].click(); return; }
        }
      });
    }
  }

  /* Footer newsletter. The form works on its own: it goes to
     Klaviyo's page and subscribes from there. This keeps the reader
     on the page instead, posting to the endpoint the old footer used.
     The response is readable from this origin (checked against the
     live store), so success and failure both show in place. If the
     request itself fails, the form is submitted the ordinary way
     rather than leaving the reader with nothing. */
  function bindNews() {
    var form = D.querySelector("[data-os-news]");
    if (!form || !window.fetch) return;
    var msg = D.querySelector("[data-os-news-msg]");
    var btn = form.querySelector("button");
    var url = form.getAttribute("data-ajax");

    function say(text, ok) {
      if (!msg) return;
      msg.textContent = text;
      msg.classList.toggle("is-ok", !!ok);
      msg.hidden = false;
    }

    form.addEventListener("submit", function (e) {
      if (!url) return;
      e.preventDefault();
      var body = new URLSearchParams(new FormData(form)).toString();
      if (btn) btn.disabled = true;
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (btn) btn.disabled = false;
          if (data && data.success) {
            form.reset();
            say(T("main.news_thanks", "Thanks for subscribing"), true);
          } else {
            var err = data && data.errors && data.errors[0];
            say(err || T("main.news_failed", "That did not go through. Check the address and try again."), false);
          }
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          form.removeAttribute("data-ajax");
          url = null;
          form.submit();
        });
    });
  }

  /* ───────────────────────────────────────────
     Go
     ─────────────────────────────────────────── */
  applyCopy();
  keepUnitsDeep(C);
  keepUnitsInPage(D.body);
  window.addEventListener("load", function () { keepUnitsInPage(D.body); });
  buildShell();
  hideFloaters();
  paintApps();
  /* App embeds (a language tab, a currency tab) are injected after this
     script runs, so the first pass can miss them. Watch the top of the
     body for a little while and catch the late arrivals too. The real
     fix is switching those embeds off; this is the belt. */
  if (window.MutationObserver) {
    var floatWatch = new MutationObserver(function () { hideFloaters(); });
    floatWatch.observe(D.body, { childList: true });
    setTimeout(function () { floatWatch.disconnect(); }, 15000);
  }

  var boxes = D.querySelectorAll(".os-who");
  for (var i = 0; i < boxes.length; i++) bindWho(boxes[i]);

  bindSearch();
  bindMore();
  bindStages();
  bindHeadHide();
  bindRegion();
  bindNews();
  bindTour();
  paintStoreLinks();
  repaint(currentId());
  markNav();

  D.addEventListener("click", function (e) {
    var a = e.target.closest("a[href*='/products/']");
    if (a) markDoor(a.getAttribute("data-os-door") || doorFromPath());

    var g = e.target.closest("[data-os-guide]");
    if (g) {
      var key = g.getAttribute("data-os-guide");
      var card = g.closest("[data-learn-id]");
      var L = LIB();
      if (card && L) L.markOpened(card.getAttribute("data-learn-id"));
      if (!key) { e.preventDefault(); return; }
      if (window.OS_READER) {
        e.preventDefault();
        window.OS_READER(key, g.getAttribute("data-guide-title") || "");
      }
    }
  });

  /* Exposed so the standalone preview can drive a page change
     without a reload. Unused on the store, where every room is a
     real URL. */
  /* glideTo is shared rather than copied: the Shop moves the page on
     a role change too, and two easing curves for the same gesture on
     two pages of the same site is the kind of difference nobody can
     name but everybody feels. */
  window.OS = {
    repaint: repaint,
    currentId: currentId,
    glideTo: glideTo,
    reducedMotion: function () { return REDUCED_MOTION; },
    resetStage: function (s) { delete stagePainted[s]; }
  };
})();

/* ─────────────────────────────────────────────
   Tracking

   osTrack(name, params) publishes an event to Shopify customer events,
   GA4 (gtag), Klaviyo (_learnq, selected events) and the dataLayer.
   Meta gets these through the "DiFluid Landing Events" custom pixel
   in Shopify admin, which subscribes to the same names; the page
   never calls fbq itself, so nothing is counted twice.

   Events: persona_selected, persona_primary (once a visit),
   cta_click, simulator_use, pour_trainer_start, pour_trainer_finish,
   feishu_form_view, feishu_form_engage, feishu_form_open_tab,
   add_to_cart_click.

   Persona model. The page always follows the reader's latest pick.
   Marketing follows a primary persona worked out from what the
   reader does:
     - a pick counts only once two more pages are viewed in the same
       visit (flicking through the menu counts for nothing)
     - stage, product and Tool pages, add to cart and the contact form
       each add to the personas they point at
     - every score halves after 60 days without new signals
     - the primary changes only when another persona leads it by 1.5x
     - a runner-up within half of the primary is kept as secondary
   Stored in localStorage "difluid_persona_score". Purchases are
   scored in Klaviyo from Placed Order, which the site can't see.
   ───────────────────────────────────────────── */
(function () {
  "use strict";
  var KLAVIYO_EVENTS = {
    persona_selected: "Selected Persona",
    feishu_form_view: "Viewed Contact Form",
    feishu_form_engage: "Started Contact Form",
    cta_click: "Clicked Website CTA",
    pour_trainer_finish: "Finished Pour Trainer",
    simulator_use: "Used Website Simulator"
  };
  var ROLES = ["producer", "exporter", "importer", "q", "roaster", "cafe", "hobby", "home", "educator", "competitor"];
  var LABEL = {
    producer: "Producer / mill", exporter: "Exporter", importer: "Importer / green buyer",
    q: "Q grader / analyst", roaster: "Roaster", cafe: "Café / barista", hobby: "Hobby brewer",
    home: "Home roaster", educator: "Educator", competitor: "Brewing competitor"
  };
  var KEY = "difluid_persona_score";
  var HALF_LIFE = 60 * 864e5, SWITCH = 1.5, MIN_PRIMARY = 3;
  var W = { pick: 5, page: 1, product: 1, tool: 0.5, cart: 3, form: 5 };

  /* What a page or product says about its reader. */
  var PAGES = [
    [/^\/pages\/farm$/, ["producer", "exporter", "importer"], "page"],
    [/^\/pages\/roast$/, ["roaster", "home"], "page"],
    [/^\/pages\/brew$/, ["cafe", "hobby", "competitor"], "page"],
    [/^\/pages\/difluid-traning-affiliate-application$/, ["educator"], "page"],
    [/^\/pages\/difluid-roast-collective-partnership$/, ["roaster"], "page"],
    [/^\/pages\/(particle-analyzer|brew-recorder|brew-controller|grinder-converter|grinder-manager|brew-ratio-calculator)-tool$/, ["cafe", "hobby", "competitor"], "tool"],
    [/^\/pages\/roast-color-analyzer$/, ["roaster", "home", "q"], "tool"],
    [/^\/pages\/coffeeos-bean-manager-tool$/, ["producer", "importer", "roaster"], "tool"]
  ];
  var PRODUCTS = [
    [/^(coffmeter-|roaster-barista-system)/, ["producer", "exporter", "importer"]],
    [/^roastery-starter-kit/, ["roaster", "home"]],
    [/^(roast-validation-system|pro-roaster-barista-bundle)/, ["q", "importer", "roaster"]],
    [/^(difluid-omix|omix-)/, ["q", "importer", "roaster", "producer"]],
    [/^(difluid-omniflux|difluid-airwave|airwave-|roast-control-system)/, ["roaster", "home"]],
    [/^omni($|-)/, ["roaster", "hobby", "cafe", "q"]],
    [/^(difluid-moment|sensory-brew-control-system)/, ["cafe", "competitor", "hobby"]],
    [/^(r2-extract|brew-control-system|microbalance|ultimate-coffee-brew-control-system|difluid-particle-analysis-coaster)/, ["cafe", "hobby", "competitor"]]
  ];
  var FORM_CATEGORY = { "Training and education": ["educator"], "Roast Collective": ["roaster"] };

  function ls(k, v) {
    try {
      if (v === undefined) return JSON.parse(localStorage.getItem(k) || "null");
      localStorage.setItem(k, JSON.stringify(v));
    } catch (e) { return null; }
  }
  function ss(k, v) {
    try {
      if (v === undefined) return JSON.parse(sessionStorage.getItem(k) || "null");
      sessionStorage.setItem(k, JSON.stringify(v));
    } catch (e) { return null; }
  }
  function picked() {
    var s = ls("difluid_persona");
    return s && LABEL[s.id] ? s : null;
  }

  function load() {
    var m = ls(KEY) || {};
    m.s = m.s || {}; m.picks = m.picks || {};
    var now = Date.now(), dt = now - (m.t || now), f = Math.pow(0.5, dt / HALF_LIFE);
    if (dt > 0) for (var r in m.s) m.s[r] = Math.round(m.s[r] * f * 1000) / 1000;
    m.t = now;
    return m;
  }
  function resolve(m) {
    var ranked = ROLES.filter(function (r) { return (m.s[r] || 0) > 0; })
      .sort(function (a, b) { return m.s[b] - m.s[a]; });
    var top = ranked[0], cur = m.primary;
    if (!top || m.s[top] < MIN_PRIMARY) {
      /* Not enough behaviour yet: a confirmed pick stands in. */
      var p = picked();
      if (!cur && p && m.picks[p.id] && m.picks[p.id].confirmed) m.primary = p.id;
    } else if (!cur || cur === top || (m.s[top] >= SWITCH * (m.s[cur] || 0))) {
      m.primary = top;
    }
    var rest = ranked.filter(function (r) { return r !== m.primary; });
    var second = rest[0];
    m.secondary = second && m.primary && m.s[second] >= 0.5 * (m.s[m.primary] || 0) ? second : null;
    return m;
  }
  function add(m, roles, w) {
    roles.forEach(function (r) { m.s[r] = (m.s[r] || 0) + w; });
  }
  function save(m) {
    var before = ls(KEY) || {};
    resolve(m);
    ls(KEY, m);
    if (before.primary !== m.primary || before.secondary !== m.secondary) syncPrimary(m, true);
  }

  function persona() { return picked(); }
  function camel(n) {
    return n.split("_").map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join("");
  }
  function osTrack(name, params) {
    var p = {};
    params = params || {};
    for (var k in params) if (Object.prototype.hasOwnProperty.call(params, k)) p[k] = params[k];
    var who = picked(), m = ls(KEY) || {};
    if (who && !p.persona) { p.persona = who.id; p.persona_label = who.label; }
    if (m.primary && !p.persona_primary) p.persona_primary = m.primary;
    p.page_path = location.pathname;
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
        Shopify.analytics.publish(name, p);
      }
    } catch (e) {}
    try { if (typeof window.gtag === "function") window.gtag("event", name, p); } catch (e) {}
    try {
      if (KLAVIYO_EVENTS[name]) (window._learnq = window._learnq || []).push(["track", KLAVIYO_EVENTS[name], p]);
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      var dl = { event: name };
      for (var j in p) dl[j] = p[j];
      window.dataLayer.push(dl);
    } catch (e) {}
    /* Behaviour that says something about the reader. */
    try {
      if (name === "add_to_cart_click" && p.handle) {
        var pm = load();
        PRODUCTS.forEach(function (row) { if (row[0].test(p.handle)) add(pm, row[1], W.cart); });
        save(pm);
      }
      if (name === "feishu_form_engage" && p.category && FORM_CATEGORY[p.category]) {
        var fm = load(); add(fm, FORM_CATEGORY[p.category], W.form); save(fm);
      }
    } catch (e) {}
  }
  window.osTrack = osTrack;
  window.osTrack.camel = camel;

  /* The primary persona, and the pick, kept on the visitor: GA4 user
     properties on every page, Klaviyo profile properties when they
     change (or once a visit), and one persona_primary event a visit
     for Meta's 30-day audiences. */
  function syncPrimary(m, changed) {
    var p = picked();
    var props = {};
    if (p) { props["DiFluid Persona"] = p.label; props["DiFluid Persona ID"] = p.id; }
    if (m.primary) { props["DiFluid Persona Primary"] = m.primary; props["DiFluid Persona Primary Label"] = LABEL[m.primary]; }
    props["DiFluid Persona Secondary"] = m.secondary || "";
    try {
      if (typeof window.gtag === "function") {
        window.gtag("set", "user_properties", { persona: p ? p.id : "", persona_primary: m.primary || "", persona_secondary: m.secondary || "" });
      }
    } catch (e) {}
    var sent = ss("os_persona_synced");
    var sig = JSON.stringify(props);
    if (changed || sent !== sig) {
      try { (window._learnq = window._learnq || []).push(["identify", props]); } catch (e) {}
      ss("os_persona_synced", sig);
    }
    if (m.primary && (changed || !ss("os_primary_sent"))) {
      osTrack("persona_primary", { persona_primary: m.primary, persona_primary_label: LABEL[m.primary], persona_secondary: m.secondary || "" });
      ss("os_primary_sent", 1);
      try {
        fetch(osRoot() + "cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes: { persona_primary: m.primary, persona_secondary: m.secondary || "" } }) }).catch(function () {});
      } catch (e) {}
    }
  }

  /* A pick waits for two more page views in the same visit before it
     counts. A newer pick replaces a waiting one. */
  window.osPersonaSync = function (fromPick) {
    var p = picked();
    if (fromPick && p) {
      ss("os_pick_pending", { id: p.id, views: 0 });
      var m = load(); m.picks[p.id] = m.picks[p.id] || { n: 0 }; m.picks[p.id].last = Date.now(); m.picks[p.id].n++;
      ls(KEY, m);
      syncPrimary(resolve(m), false);
    }
  };

  function onPageView() {
    var m = load(), path = location.pathname.replace(/\/$/, "");
    path = path.replace(/^\/[a-z]{2}(-[a-z]{2,4})?(?=\/)/i, ""); /* /pt/pages/brew → /pages/brew */
    PAGES.forEach(function (row) { if (row[0].test(path)) add(m, row[1], W[row[2]]); });
    var ph = path.match(/^\/(?:collections\/[^/]+\/)?products\/([^/?#]+)/);
    if (ph) PRODUCTS.forEach(function (row) { if (row[0].test(ph[1])) add(m, row[1], W.product); });
    var pend = ss("os_pick_pending");
    if (pend) {
      pend.views++;
      var p = picked();
      if (!p || p.id !== pend.id) { ss("os_pick_pending", null); }
      else if (pend.views >= 2) {
        add(m, [pend.id], W.pick);
        m.picks[pend.id] = m.picks[pend.id] || { n: 1 };
        m.picks[pend.id].confirmed = Date.now();
        ss("os_pick_pending", null);
      } else ss("os_pick_pending", pend);
    }
    save(m);
    syncPrimary(ls(KEY) || m, false);
  }
  window.addEventListener("load", function () { setTimeout(onPageView, 1500); });

  /* CTA clicks: OS buttons and anything marked data-os-cta. */
  document.addEventListener("click", function (e) {
    var el = e.target && e.target.closest && e.target.closest(".os-btn, [data-os-cta], .os-pg__framelink");
    if (!el) return;
    if (el.classList.contains("os-pg__framelink")) {
      osTrack("feishu_form_open_tab", { category: formCategory(el) });
      return;
    }
    if (el.matches("[data-os-pd-add]")) return; /* tracked by the product page */
    var sec = el.closest(".shopify-section");
    osTrack("cta_click", {
      label: (el.getAttribute("data-os-cta") || el.textContent || "").replace(/\s+/g, " ").trim().slice(0, 80),
      href: el.getAttribute("href") || "",
      section: sec ? sec.id.replace(/^shopify-section-(template--\d+__)?/, "") : ""
    });
  }, true);

  /* The Feishu frame carries its category in the prefill. */
  function formCategory(el) {
    var sec = el && el.closest(".os-pg__embed");
    var f = sec && sec.querySelector("iframe");
    var m = f && /prefill_Category=([^&]+)/.exec(f.getAttribute("src") || "");
    try { return m ? decodeURIComponent(m[1]) : ""; } catch (e) { return ""; }
  }

  /* Frames. A click into a cross-origin or sandboxed frame never
     reaches the page, but the page loses focus to it, which can be
     seen. Each frame is counted once per page view. */
  var seen = typeof WeakSet === "function" ? new WeakSet() : null;
  function frameKind(f) {
    if (!f || f.tagName !== "IFRAME") return null;
    if (f.closest(".os-pg__frame")) return "feishu";
    if (f.classList.contains("os-fr__frame") || f.classList.contains("os-walk__doc")) return "sim";
    return null;
  }
  window.addEventListener("blur", function () {
    setTimeout(function () {
      var f = document.activeElement, kind = frameKind(f);
      if (!kind || (seen && seen.has(f))) return;
      if (seen) seen.add(f);
      if (kind === "feishu") osTrack("feishu_form_engage", { category: formCategory(f) });
      else osTrack("simulator_use", { simulator: f.getAttribute("title") || "" });
    }, 0);
  });

  /* The contact form coming into view. */
  if ("IntersectionObserver" in window) {
    var watch = function () {
      var frames = document.querySelectorAll(".os-pg__frame iframe");
      if (!frames.length) return;
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting) { osTrack("feishu_form_view", { category: formCategory(en.target) }); io.unobserve(en.target); }
        });
      }, { threshold: 0.35 });
      frames.forEach(function (f) { io.observe(f); });
    };
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watch);
    else watch();
  }
})();
